import React, { Dispatch, SetStateAction } from 'react'
import { APIResponse, ErrorWithErrData, IVehicle, RecentlyOpenedEntity } from '@cbgms/api'
import { ESearchFilterValue, IMenuItem } from '../topSearchUtils'
import { ITopSearchResultProps } from '../search-v2/ResultsV2/ResultComponentSelectorV2'
import { QueryObserverResult } from '@tanstack/react-query'

export interface ITopSearchContextExpose {
  showSearchFilter: boolean // show/hide the search categories filter  (only in search-v2 implementation)
  searchFilter: ESearchFilterValue // search in specific categrory
  setSearchFilter: (value: ESearchFilterValue) => void
  menuOptions: IMenuItem[] // search category menu options
  searchPlaceholder: string // translation key for placeholder search text
  noResultsPlaceholder: string // translations key for no-results message
  loading: boolean
  results: ITopSearchResultProps[]
  clearQuery: () => void
  setQuery: (value: string) => void
  query: string // the current search term
  silentErrors: ErrorWithErrData[]
  recentlyOpenedEntities: ITopSearchResultProps[]
  refetchRecentlyOpenedEntities: () => Promise<QueryObserverResult<APIResponse<RecentlyOpenedEntity[]>>>

  onClose: () => void
  setOpen: Dispatch<SetStateAction<boolean>>
  open: boolean

  GetVehicleData: (uuid: string) => { data: IVehicle | null | undefined; isLoading: boolean }
}

export const TopSearchContext = React.createContext<ITopSearchContextExpose | undefined>(undefined)

/**
 * useTopSearchContext is a container context for all topsearch related data and functions
 * @returns
 */
export const useTopSearchContext = () => {
  const context = React.useContext(TopSearchContext)
  if (context === undefined) {
    throw new Error('useTopSearchContext must be used within a TopSearchContext')
  }
  return context
}
